module.exports = __webpack_public_path__ + "media/images/compare_version-6b0c31fc.png";